<template>
  <div>
    <div class="goodsItemListfour">
      <div
        class="goodsFlex"
        @click.prevent="goUrl(item.product_id)"
        v-for="item in goodsListshome"
        :key="item.product_id"
      >
        <div class="goodsImgfour">
          <!-- <div class="activity" v-if="item.external_type == 5">
            买{{ item.external.buy_num }}送{{ item.external.gift_num }}
          </div> -->
          <img :src="item.background" class="images" alt="" />
          <div class="soldOut" v-if="!item.isSoom">COMING SOON</div>
        </div>
        <div class="goodsTitle">{{ item.cn_name }}</div>
        <div
          class="zkFlexs"
          v-if="Number(item.price_eur) > 0 || item.external_type == 5"
        >
          <div class="offzkou" v-if="Number(item.price_eur) > 0">
            {{ couponStrength(item) }}off
          </div>
          <div
            :class="Number(item.price_eur) > 0 ? 'offzkou mleft5' : 'offzkou'"
            v-if="item.external_type == 5"
          >
            买{{ item.external.buy_num }}送{{ item.external.gift_num }}
          </div>
        </div>
        <div
          class="spces"
          v-else
          v-html="item.goods[0].spec[0].spec_value_name"
        ></div>
        <div class="bottomPrice" style="height: 100%">
          <div class="priceFlex">
            <div class="flexnhsag">
              <div class="flexPricepoin">
                <div
                  class="priceasxsa"
                  v-html="'€' + formPrice(item.goods[0].spec_price)"
                ></div>
                <!-- <div class="decPoin">.32</div> -->
              </div>
              <div class="oldprice" v-if="Number(item.price_eur) > 0">
                €{{ item.price_eur }}
              </div>
            </div>
          </div>
          <img
            src="/images/newpcImg/addcart.png"
            @click.stop="showCart(item)"
            class="addcarticon"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="moreGoods" @click="getProductHome(1)">更多商品</div>
  </div>
</template>

<script>
import cart from "../lib/dialog/cart-dialog";
import formPrice from "./formPrice";

export default {
  data() {
    return {
      goodsListshome: [],
      formPrice: formPrice,
      page: 1,
    };
  },
  mounted() {
    this.getProductHome();
  },
  computed: {},
  methods: {
    couponStrength(item) {
      const pricesa = item.spec_price
        ? item.spec_price
        : item.goods && item.goods[0]
        ? item.goods[0].spec_price
        : 0;
      const priceStren = Number(
        (
          ((Number(item.price_eur) - Number(pricesa)) /
            Number(item.price_eur)) *
          100
        ).toFixed(0)
      );
      return priceStren > 99 ? 99 + "%" : priceStren + "%";
    },
    async getProductHome(page) {
      if (page) {
        this.page = this.page + 1;
      }
      const data = await this.$json.get("product/api/home", {
        params: {
          page: this.page,
          size: 20,
        },
      });
      data.data.data.forEach((e) => {
        const numList = [];
        e.goods.forEach((s) => {
          if (s.num > 0) {
            numList.push(s.num);
          }
        });
        if (numList.length > 0) {
          e.isSoom = true;
        }
      });
      this.goodsListshome = this.goodsListshome.concat(data.data.data);
    },
    goUrl(id) {
      // 决定用location
      const route = window.location;
      const localLang = localStorage.getItem("localLang");
      let url;
      url = `${route.origin}${
        localLang != "en" ? "/" + localLang : ""
      }/product/${id}`;
      route.href = url;
    },
    showCart(goodsDetails) {
      cart(goodsDetails);
    },
  },
};
</script>

<style lang="scss" scoped>
.moreGoods {
  cursor: pointer;
  margin: 0 auto;
  width: 13.8462rem;
  height: 1.5385rem;
  background: #ffffff;
  border: 1px solid #cacaca;
  margin-top: 1.5385rem;
  font-size: 0.6154rem;
  text-align: center;
  line-height: 1.5385rem;
  font-weight: 400;
  color: #666;
}
.goodsItemListfour {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 0.7692rem;
  align-items: center;
  flex-wrap: wrap;

  .goodsFlex {
    background-color: #fff;
    padding: 0.7692rem;
    margin-top: 0.7692rem;
    // margin-left: .3846rem;

    .goodsTitle {
      height: 1.4615rem;
      font-size: 0.5385rem;
      font-weight: 500;
      color: #333;
      width: 100%;
      overflow: hidden; //超出的文本隐藏
      display: -webkit-box;
      -webkit-line-clamp: 2; // 超出多少行
      -webkit-box-orient: vertical;
      margin-top: 0.3846rem;
    }

    .mleft5 {
      margin-left: 5px;
    }

    .zkFlexs {
      display: flex;
      align-items: center;
      margin-top: 0.3846rem;
    }

    .offzkou {
      font-size: 0.4615rem;
      font-weight: 500;
      color: #ff5600;
      padding: 3px 5px;
      background: #fff0e5;
      border-radius: 2px;
    }

    .spces {
      font-size: 0.5385rem;
      font-weight: 500;
      color: #999;
      margin-top: 0.3846rem;
    }

    .priceFlex {
      display: flex;
      flex-direction: column;

      .oldprice {
        text-decoration: line-through;
        font-size: 0.4615rem;
        font-weight: 500;
        color: #999;
      }

      .decPoin {
        font-size: 0.5385rem;
        font-weight: bold;
        color: #ff7802;
      }

      .priceasxsa {
        font-size: 0.7692rem;
        font-weight: bold;
        color: #ff7802;
      }
      .tofixedPrices {
        font-weight: 600 !important;
        font-size: 0.5385rem !important;
      }
    }

    .bottomPrice {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-top: 0.5769rem;
      height: 2.0385rem;
      padding-bottom: 0.1923rem;

      .addcarticon {
        width: 1.1538rem;
        height: 1.1538rem;
      }
    }

    .goodsImgfour {
      width: 100%;
      height: 9.4231rem;
      position: relative;
      overflow: hidden;
      transition: all 0.5s;
      cursor: pointer;

      .oneadone {
        position: absolute;
        top: 0.3077rem;
        left: 0.3846rem;
        font-size: 0.5385rem;
        font-weight: 500;
        color: #fff;
        background: #ff5600;
        padding: 0.1154rem 0.3077rem;
      }

      .dataBest {
        padding: 0.0769rem 0;
        position: absolute;
        left: 0;
        bottom: 0px;
        width: 100%;
        font-size: 0.4615rem;
        font-weight: 500;
        color: #ff5600;
        text-align: center;
        background: #fff0e5;
        white-space: nowrap;
      }

      .waitgoods {
        position: absolute;
        left: 0;
        bottom: 0px;
        padding: 0.0769rem 0;
        width: 100%;
        text-align: center;
        background: #ff7802;
        font-size: 0.4615rem;
        font-weight: 500;
        color: #fff;
      }

      .lowinstock {
        position: absolute;
        left: 0;
        bottom: 0px;
        padding: 0.0769rem 0;
        width: 100%;
        text-align: center;
        background: rgba(51, 51, 51, 0.6);
        font-size: 0.4615rem;
        font-weight: 500;
        color: #fff;
      }

      .soldOut {
        position: absolute;
        bottom: 0px;
        left: 0px;
        text-align: center;
        width: 100%;
        padding: 0.0769rem 0;
        background: #ff7802;
        font-size: 0.4615rem;
        font-weight: 500;
        color: #fff;

        .wait {
          width: 3.0769rem;
          height: 3.0769rem;
          display: flex;
          align-items: center;
          border-radius: 50%;
          flex-direction: column;
          justify-content: center;
          background: rgba(51, 51, 51, 0.6);

          div {
            font-size: 0.6154rem;
            font-weight: 500;
            color: #fff;
          }
        }
      }

      .images {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .goodsImgfour:hover {
      transform: scale(1.1);
      cursor: pointer;
    }
  }

  .goodsFlex:first-child {
    margin-left: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/anystorlingGoods.vue